export const home = {
  meta: {
    title: {
      absolute: "HealthVoitho — Intelligent healthtech in the cancer ecosystem",
    },
    description:
      "A research-oriented technology organisation in the Esperer Group. We develop intelligent systems for earlier, more accessible cancer care.",
  },
  hero: {
    /** Locked — do not change */
    headline: "Intelligent Healthtech in Cancer Ecosystem. Accessible Everywhere.",
    headlineLines: [
      "Intelligent Healthtech",
      "in Cancer Ecosystem.",
      "Accessible Everywhere.",
    ] as const,
    deck: "We build the intelligence that helps cancer be found earlier, understood sooner, and faced closer to home.",
    primaryCta: { href: "/science", label: "Science" },
    secondaryCta: { href: "/partnerships", label: "Partner with us" },
  },
  progress: {
    title: "The Work That Moves Care Forward",
    cards: [
      {
        title: "From Detect & Treat to Assess & Prevent",
        standfirst:
          "Health Voitho is the technology partner for Saltlick Healthcare Pvt Ltd, building an AI-enabled cancer risk-assessment ecosystem designed to move care from reactive detection toward earlier, preventive action.",
        image: "/media/saltlick.jpeg",
        imageAlt: "Saltlick Healthcare Pvt Ltd logo",
        href: "/salt-lick",
        eyebrow: null,
        ctaLabel: "Learn more",
        isLogoMedia: true,
        imageClassName: "scale-[0.82] object-contain",
      },
      {
        title: "Precision Nutrition for Every Cancer Patient",
        standfirst:
          "Health Voitho is the exclusive technology partner behind Nutra-IQ, Esperer Onco Nutrition's proprietary AI-supported protocol that converts multidomain clinical and nutritional data into individualized nutrient guidance throughout cancer care.",
        image: "/media/NIQ_Logo_HighRes_Transparent.png",
        imageAlt: "Nutra-IQ product logo",
        href: "/nutra-iq",
        eyebrow: null,
        ctaLabel: "Learn more",
        isLogoMedia: true,
        imageClassName: "scale-[0.68] object-contain",
      },
      {
        title: "Chronic Pain Relief, Without the Medication",
        standfirst:
          "Health Voitho is the exclusive partner bringing the device-based solution, a European-engineered auricular vagus nerve stimulation (aVNS) technology, to India, offering a drug-free, minimally invasive way to treat chronic pain, including in cancer patients.",
        image: "/media/chronic-pain-neck-relief-v4.png",
        imageAlt: "A man holding his neck while experiencing chronic pain",
        href: "/chronic-pain-relief",
        eyebrow: null,
        ctaLabel: "Learn more",
        isLogoMedia: false,
        imageClassName: "object-cover object-[68%_center]",
      },
      {
        title: "Selfie-Based Health Vitals",
        standfirst:
          "VitalIQ turns any smartphone into a clinical-grade screening device. A 60-second scan reads 20 vital signs, with no wearables, blood draw, or clinic visit. AI-powered, CDSCO and USFDA licensed, and clinically validated.",
        image: "/media/VitalIQ_Logo_HighRes_Transparent.png",
        imageAlt: "VitalIQ product logo",
        href: "/vitaliq",
        eyebrow: null,
        ctaLabel: "Learn more",
        isLogoMedia: true,
        imageClassName: "scale-[0.62] object-contain",
      },
      {
        title: "VitalZ-Pro®: Diagnostic Clarity in Minutes",
        standfirst:
          "More than 150 health parameters from one portable point-of-care system, supporting rapid screening across cardiovascular, metabolic, infectious, hormonal, nutritional, organ-health, and select cancer-marker domains.",
        image: "/media/vitalz-pro/vitalz-pro-hero-v2.png",
        imageAlt: "VitalZ-Pro portable diagnostic system in use during point-of-care screening",
        href: "/vitalz-pro",
        eyebrow: null,
        ctaLabel: "Learn more",
        isLogoMedia: false,
        imageClassName:
          "object-cover object-center group-hover:scale-[1.025] group-focus-visible:scale-[1.025]",
      },
    ],
  },
  scienceOverview: {
    titleAccent: "AI",
    title: " + Domain Expertise",
    mechanism:
      "We combine longitudinal oncology data, AI-driven causal modelling and deep domain expertise into solutions our partners use to validate targets, biomarkers and diagnostic pathways before committing capital downstream.",
    pillars: [
      {
        title: "AI-Driven Causal Modelling",
        description:
          "We apply AI/ML and causal inference to real-world oncology data to identify disease targets and patient subtypes, and validate them before a partner commits lab or clinical resources.",
      },
      {
        title: "Longitudinal Oncology Data",
        description:
          "Structured data spanning the full disease journey — not a single snapshot — so every model is grounded in how cancer actually progresses in a population, not just in published literature.",
      },
      {
        title: "Deep Domain Knowledge",
        description:
          "Oncology-specific clinical and scientific expertise embedded at every step, so a partner's R&D or clinical team gets an interpretable output, not a black-box score.",
      },
    ],
    cta: { href: "/science", label: "Explore the science behind it" },
  },
  origin: {
    title: "What’s in a name?",
    definition:
      'We named ourselves after a promise. Voitho is Greek for "to assist" and a health company that keeps that promise is the only kind worth building.',
    purpose:
      "We enable scientists, clinicians and institutions to harness the collective wisdom and the power of technology to uncover knowledge for the future of cancer care. We do so to help people everywhere live healthier and happier.",
  },
} as const;
